export default __webpack_public_path__ + "static/media/bannervideo.f275511c.mp4";